import { isInteger } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';

import { getDurationTime } from '../../utils/date';

const FORMAT = 'mm:ss';

const Duration = React.memo(({ duration, ...props }) => {
  if (!isInteger(duration) || duration < 0) {
    return null;
  }

  const durationTime = getDurationTime({ seconds: duration });

  return (
    <StyledDuration {...props}>{format(durationTime, FORMAT)}</StyledDuration>
  );
});

Duration.displayName = 'Duration';
Duration.propTypes = {
  className: PropTypes.string,
  duration: PropTypes.number.isRequired,
};

Duration.defaultProps = {
  className: '',
};

const StyledDuration = styled.div`
  color: #4d4d4d;
  font-size: 12px;
`;

export default Duration;
